export const getEdits = (project) => {
    return new Promise(async (resolve, reject) => {
        let query = {project}
        fetch('/projectEdits/' , {
            method: 'POST',
            body: JSON.stringify(query),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then(resp => resp.json())
            .then(resp => {
                resolve(resp);
            });
    });
};
